import { ReferenceSearchResponse } from '@qualio/search-qri';
import axios from 'axios';

export const globalSearchServiceApiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  baseURL: process.env.REACT_APP_GLOBAL_SEARCH_SERVICE_URL,
  withCredentials: true,
});

export const globalSearchServiceApi = {
  async getReferences(
    qris: string[],
    direction: 'to' | 'from' | 'both',
    companyId: number,
  ): Promise<ReferenceSearchResponse> {
    const result = await globalSearchServiceApiClient.post('/v2/references', {
      qris,
      direction,
      companyId,
    });
    return result.data;
  },
};
